'use strict';

import React from "react";
import classNames from "classnames";
import {isNumeric} from "../../util";

const mapValToColor = (v) => {
    if (v < 0.25) {
        return "bracket_lt25";
    }
    else if (v < 0.5) {
        return "bracket_lt50";
    }
    else if (v < 0.75) {
        return "bracket_lt75";
    }
    else {
        return "bracket_lte100";
    }
};

const context = {
    missense: {
        keyDomainScores: [
            { name: 'C0', value: 0.03 },
            { name: 'C15-C25', value: 0.29 },
            { name: 'C35-C55', value: 0.66 },
            { name: 'C65', value: 0.81 },
            ],
        irrelevant: 0.02
    },
    silentVal: 0.02,
    nonsenseGrayZonVal: 0.5,
    nonsenseVal: 0.99
};

function labelClasses(v) {
    return classNames('label-field borderless ', mapValToColor(v));
}

function rowClasses(v, probability, canBeHighlighted) {
    if (canBeHighlighted === false) {
        return classNames('field-container');
    } else {
        return classNames('field-container', probability === v ? 'highlighted' : null);
    }
}

export default class ProteinLevelSubtile extends React.Component {
    render() {
        const {probability, synonymous} = this.props;

        if (!isNumeric(probability) || probability === -Infinity) {
            return (
                <div className="subtile-container">
                The Protein-level estimation is not applicable because the variant is not inside an exon, and thus is not associated with estimated protein-level impact.
                </div>
            );
        }

        return (
            <div className="subtile-container">
                <div className="protein-level-estimation" style={{border: 'solid 1px #eee', borderRight: 'none'}}>
                    <div className="field-container">
                        <div className="label-field borderless" />
                        <div className="value-field">
                            Probability
                        </div>
                    </div>

                    <div className="field-container">
                        <div className="label-field missense-header borderless">Missense (nonsynonymous)</div>
                        <div className="value-field" style={{border: 'none'}} />
                    </div>

                    <div className="nested">
                        <div className="field-container">
                            <div className="label-field" style={{border: 'none'}}>Inside key domains</div>
                        </div>

                        {
                            context.missense.keyDomainScores.map(x => (
                                <div key={x.name} className={rowClasses(x.value, probability)}>
                                    <div className={labelClasses(x.value)}>Align GV-GD score: {x.name}</div>
                                    <div className="value-field">{x.value}</div>
                                </div>
                            ))
                        }

                        <div className="field-container">
                            <div className="label-field" style={{border: 'none', marginTop: '0.5em'}}>Outside key domains</div>
                        </div>

                        <div className={rowClasses(context.missense.irrelevant, probability, (synonymous === false))}>
                            <div className={labelClasses(context.missense.irrelevant)}>
                                <i>Missense severity irrelevant</i>
                            </div>
                            <div className="value-field">{context.missense.irrelevant}</div>
                        </div>
                    </div>

                    <div className={rowClasses(context.silentVal, probability, (synonymous === true))} style={{marginTop: '1em'}}>
                        <div className={labelClasses(context.silentVal)}>
                            Silent (synonymous)
                        </div>
                        <div className="value-field">{context.silentVal}</div>
                    </div>

                    <div className={rowClasses(context.nonsenseGrayZonVal, probability)} style={{marginTop: '1em'}}>
                        <div className="label-field missense-header borderless">
                            Nonsense in Grey Zone
                        </div>
                        <div className="value-field">{context.nonsenseGrayZonVal}</div>
                    </div>

                    <div className={rowClasses(context.nonsenseVal, probability)} style={{marginTop: '0em'}}>
                        <div className={labelClasses(context.nonsenseVal)}>
                            Nonsense
                        </div>
                        <div className="value-field">{context.nonsenseVal}</div>
                    </div>
                </div>
            </div>
        );
    }
}
